import React, { useState } from "react";
import { Modal, Button, Image } from "react-bootstrap";
import Files from "react-files";
import "./styles.scss";

export default function ChooseImage(props) {
  const [file, setFile] = useState(null);
  const { setImageFile, show, onClose } = props;
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header>
        <Modal.Title>Image Uploader</Modal.Title>
      </Modal.Header>

      <Modal.Body className="choose-image-modal-body">
        <div>
          <p>
            *Recommendations: 1. Compressed Images 2. Size: > 400 X 400
            (Preferrably Squares)
          </p>
        </div>
        <Files
          className="files-dropzone d-flex justify-content-center h-100"
          onChange={(files) => setFile(files[0])}
          onError={(error) => alert("Error: ", error.message)}
          accepts={["image/*"]}
          clickable
        >
          {!file ? (
            <strong className="align-self-center">
              Drag file here or click here to select an image
            </strong>
          ) : (
            <Image className="w-100 h-100" src={URL.createObjectURL(file)} />
          )}
        </Files>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            setImageFile(file);
            onClose();
          }}
        >
          Save changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
